module.exports = __webpack_public_path__ + "static/media/S14_black.5a8726da.png";